import React from 'react'
import { ErrorMessage } from '@sketch/components'
import { PrototypeViewHeaderEmpty } from '../PrototypeViewHeader'
import PageLayout from 'layouts/PageLayout'

import * as S from './PrototypeErrorPage.styles'

type PrototypeErrorPageProps = {
  errorTitle: string
  errorDescription?: React.ReactNode
  errorExtra?: React.ReactNode
  icon: React.ReactNode
}

/**
 * Generic layout to display an error on the prototype page.
 */
export function PrototypeErrorPage({
  errorTitle,
  errorDescription,
  errorExtra,
  icon,
}: PrototypeErrorPageProps) {
  return (
    <PageLayout header={<PrototypeViewHeaderEmpty />}>
      <S.PrototypeErrorPage>
        <ErrorMessage
          dark
          icon={icon}
          iconSize="medium"
          title={errorTitle}
          description={errorDescription}
          extra={errorExtra}
        />
      </S.PrototypeErrorPage>
    </PageLayout>
  )
}
